var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvOuterwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2795 8.26346L20.0112 6.1145C20.0112 6.1145 20.294 7.62982 15.2109 10.1793C17.8965 10.1566 20.2795 8.26346 20.2795 8.26346Z",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5881 6.96685C10.5881 6.96685 10.1672 6.47461 10.1055 5.98575C10.1055 5.98575 11.212 3.92125 15.0964 4.00233C15.0964 4.00233 18.3379 3.95696 19.9493 5.81926C20.207 6.34094 19.6114 7.07061 19.6114 7.07061",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 8.27855L10.1024 6.00171C10.1024 6.00171 10.0773 7.64491 15.1584 10.1949C12.4719 10.1722 10.0898 8.27855 10.0898 8.27855Z",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3027 17.5952V10.0461",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 17.5977V10.0486",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8259 25.648C20.2984 25.5515 20.3625 24.8359 20.3625 24.8359L20.3437 15.1195L20.337 15.0447L21.3953 24.5067C21.3953 24.5067 21.4276 25.7257 22.0048 25.8218C22.6182 25.7417 23.5124 25.5974 23.5124 25.5974C23.5124 25.5974 24.0577 25.2446 23.995 24.0898C23.9322 22.935 22.776 10.907 22.776 10.907C22.776 10.907 22.6399 8.76237 20.2554 8.27979C17.2923 10.3626 15.0367 10.2101 15.0367 10.2101C15.0367 10.2101 12.4607 10.1619 10.054 8.28413C10.054 8.28413 7.58802 8.95637 7.31488 10.3486C7.04173 11.7409 6.00224 24.3016 6.00224 24.3016C6.00224 24.3016 5.94723 25.3426 6.38204 25.6283C6.84194 25.7402 7.84041 25.8749 7.84041 25.8749C7.84041 25.8749 8.41952 25.8749 8.56864 24.5719C8.71775 23.2689 9.60668 15.1132 9.60668 15.1132L9.58786 24.8296C9.58786 24.8296 9.65204 25.5462 10.1259 25.6427L19.8259 25.648Z",
    stroke: "#61A578",
    strokeWidth: 0.77336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvOuterwear);
export default __webpack_public_path__ + "static/media/revv_outerwear.411c3fc4becd8c328bb13cc9d8024a07.svg";
export { ForwardRef as ReactComponent };